import { useEntitlementQuery } from '@mentimeter/entitlements';
import { useSuspenseFlag } from '@mentimeter/flags/confidence/client';

export const useWorkspaceCollaborationEntitlement = () => {
  const { value: newBusinessModel } = useSuspenseFlag(
    'bees-business-remodel.enabled',
    false,
  );

  const entitlementName = newBusinessModel
    ? 'workspaceCollaboration'
    : 'workspaceCollaborationLegacy';

  return useEntitlementQuery(entitlementName);
};
